<div class="container">
  <div>

  </div>
  <div>
    <ion-row>
      <ion-col size="4">
        <div class="formLabelSemiBoldfs16 mb-5"> Recommended By {{this.probationCurrentLogUserType || confirmationProbationWhomSetup}} </div>
      </ion-col>
      <ion-col size="8" class="text-right">
        <img (click)="closepopup()" class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>
    <div class="p-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
              <thead>
                <tr>

                  <th *ngFor="let item of OfferAndAppointmentTableHeader" class="fs-14 font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style" style="width: 80px;">
                      {{ item?.label }}

                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let employee of lineManagerOrHODData; let i = index">
                  <!-- Sr. No -->
                  <td>{{ i + 1 }}</td>
                  <td>{{ employee.emplCode }}</td>
                  <td>{{ employee.empName }}</td>
                  <td>{{ employee.empDept }}</td>
                  <td>{{ employee.band}}</td>
                  <td>{{ employee.grade }}</td>
                  <td>{{ employee.dateOfJoining | date:'dd-MM-yyyy' }}</td>
                  <td>{{ employee.dateOfConfirmation | date:'dd-MM-yyyy' }}</td>

                  <td>

                    <mat-form-field class="w-90 mat-height40 mat-input-style" (click)="confirmationpopp(employee)">
                      <!-- <mat-select placeholder="select probation " (ngModelChange)="getprobationData(employee)"  [disabled]="(loggedInUserRole=='HR Admin') && !isEditable(employee)"
                      [(ngModel)]="employee.probationStatus"(selectionChange)="onProbationChange(employee)">
                        <mat-option [value]="'Confirmation'" [disabled]="!confirmationFlag">
                          Confirm
                        </mat-option>
                        <mat-option [value]="'Extension'">
                          Extension
                        </mat-option>

                      </mat-select> -->
                      <mat-select placeholder="Select Probation" (ngModelChange)="getprobationData(employee)"
                        [disabled]="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')|| !isEditable(employee)"
                        [(ngModel)]="employee.probationStatus" (selectionChange)="onProbationChange(employee)">

                        <mat-option [value]="'Confirmation'" [disabled]="!confirmationFlag">
                          Confirm
                        </mat-option>
                        <mat-option [value]="'Extension'">
                          Extension
                        </mat-option>

                      </mat-select>

                    </mat-form-field>
                  </td>

                  <td> {{employee.probationExtensionByDay}}</td>
                  <td>
                    <!-- [disabled]="(loggedInUserRole!=='HOD'||loggedInUserRole!=='Manager') && !isEditable(employee)" -->
                    <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="employee.reasonForExtension"
                      [disabled]="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')" maxlength="255"
                      (ngModelChange)="getprobationData(employee)" [ngModelOptions]="{standalone: true}"></textarea>
                  </td>
                  <!-- <td *ngIf="loggedInUserRole=='HR Admin'"> <mat-form-field class="w-90 mat-height40 mat-input-style">
                      <mat-select placeholder="select probation  "(ngModelChange)="getprobationData(employee)" [(ngModel)]="employee.changesPostConfirmation"
                       [disabled]="employee.probationStatus !=='Confirmation'">
                        <mat-option [value]="'No_Change'">
                          No Change
                        </mat-option>
                        <mat-option [value]="'Change_Needed'" (click)="onClickOpenChangeNeededPopup(employee.userId)">
                          Change Needed
                        </mat-option>

                      </mat-select>
                    </mat-form-field></td> -->
                  <td *ngIf="loggedInUserRole !== 'HR Admin'&&loggedInUserRole !== 'Super Admin' && loggedInUserRole !== 'PHI Admin'">
                    <button type="button" class="add_btn fs-14 float-right center-content mr-5"
                      [style.background-color]="buttonColorName" (click)="SaveProbationData(employee.userId)">
                      save</button>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>